import { Helper } from '../../../js/util/helper';
import Siema from '../../../js/vendor/siema';

export default class JumpNavigation {
  constructor( node ) {
    this.node = node;
    this.slider = null;
    // each jump-mark has a width of 192px
    this.elementWidth = 192;
    this.elements = this.node.children[ 0 ].children;
    this.elementsLength = this.elements.length;
    this.placeholder = document.getElementsByClassName( 'jump-navigation--placeholder' )[ 0 ];
    this.header = document.getElementsByClassName( 'header' )[ 0 ];
    this.initPosition = this.node.getBoundingClientRect().top + window.pageYOffset;
    this.drupalHeight = 0;
    this.jumpMarks = [];

    this.windowPosition = window.pageYOffset;
    this.scrollDirectionDown = true;

    this.findJumpMarks();

    this.handleScrollEvent();
    this.watchForModule();

    if ( window.innerWidth >= 1024 ) {
      this.handleSlider();
    }
    this.handleButtonClick();
    this.handleResizeEvent();

    if ( window.innerWidth >= 1024 && this.node.classList.contains( 'jump-navigation--sticky' )) {
      this.placeholder.style.height = this.node.offsetHeight + 'px';
    }

    document.body.addEventListener( 'header-transition-end', () => {
      this.handleScrollEvent();
    });
  }
  watchForModule() {
    window.addEventListener( 'scroll', this.handleScrollEvent.bind( this ));
  }
  handleScrollEvent() {
    let headerHeight = this.header.offsetHeight;
    let bodyPadding = document.body.style.paddingTop;

    if ( bodyPadding !== '' ) {
      this.drupalHeight = parseInt( bodyPadding.split( 'px' )[ 0 ]);
    } else {
      this.drupalHeight = 0;
    }

    if ( window.innerWidth >= 1024 ) {

      if ( this.windowPosition > window.pageYOffset ) {
        this.scrollDirectionDown = false;
        this.windowPosition = window.pageYOffset;
      } else {
        this.scrollDirectionDown = true;
        this.windowPosition = window.pageYOffset;
      }

      if (( headerHeight >= this.node.getBoundingClientRect().top ) && !this.node.classList.contains( 'jump-navigation--sticky' )) {
        let h = this.node.offsetHeight;
        this.placeholder.style.height = h + 'px';
        this.node.classList.add( 'jump-navigation--sticky' );
        this.node.style.top = ( headerHeight + this.drupalHeight ) + 'px';
        if ( this.node.querySelector( '.jump-navigation__slider' )) {
          this.buildNew();
        }
      }

      if (( window.pageYOffset <= ( this.initPosition - headerHeight - this.placeholder.offsetHeight + 45 )) && this.node.classList.contains( 'jump-navigation--sticky' )) {
        this.placeholder.style.height = '0px';
        this.node.classList.remove( 'jump-navigation--sticky' );
        this.node.style.top = 'inherit';
        if ( this.node.querySelector( '.jump-navigation__slider' )) {
          this.buildNew();
        }
      }

      if ( this.node.classList.contains( 'jump-navigation--sticky' ) && headerHeight !== this.node.style.top ) {
        this.node.style.top = ( headerHeight + this.drupalHeight ) + 'px';
      }
    }
  }
  handleSlider() {
    // 120 = 2 * width of the arrow button for the slider
    let visible = Math.floor(( this.node.offsetWidth - 120 ) / this.elementWidth );
    let items = this.node.children[ 0 ];


    if ( visible < this.elementsLength ) {
      if ( !items.classList.contains( 'jump-navigation__items--slider' )) {
        items.classList.add( 'jump-navigation__items--slider' );
        this.node.classList.add( 'jump-navigation--slider' );
      }
      this.slider = new Siema({
        selector: this.node.children[ 0 ],
        perPage: visible,
        loop: false,
        onChange: this.checkButton.bind( this )
      });
      items.children[ 0 ].classList.add( 'jump-navigation__slider' );
      items.children[ 0 ].style.height = items.offsetHeight + 'px';
    } else {
      this.removeSliderClass();
    }
  }
  handleResizeEvent() {
    window.addEventListener( 'resize', Helper.debounce(() => {
      this.buildNew();
    }, 250 ));
  }
  buildNew() {
    if ( this.slider !== null ) {
      this.slider.destroy( true );
      this.slider = null;
      this.removeSliderClass();
    }

    if ( window.innerWidth >= 1024 ) {
      this.handleSlider();
    } else {
      if ( this.node.style.top !== 0 ) {
        this.node.style.top = 'inherit';
        this.node.nextSibling.nextSibling.style.height = '0px';
      }
    }
  }
  removeSliderClass() {
    if ( this.node.children[ 0 ].classList.contains( 'jump-navigation__items--slider' )) {
      this.node.children[ 0 ].classList.remove( 'jump-navigation__items--slider' );
      this.node.classList.remove( 'jump-navigation--slider' );
    }
  }
  handleButtonClick() {
    let buttons = this.node.querySelectorAll( '.jump-navigation__button' );

    for ( let button of buttons ) {
      button.addEventListener( 'click', () => {
        if ( button.classList.contains( 'jump-navigation__button--left' )) {
          this.showPrev( button );
        } else if ( button.classList.contains( 'jump-navigation__button--right' )) {
          this.showNext( button );
        }
      });
    }
  }
  showPrev( prev ) {
    this.slider.prev();

    let next = prev.nextSibling;

    if ( next.nextSibling.classList.contains( 'jump-navigation__button--hidden' )) {
      next.nextSibling.classList.remove( 'jump-navigation__button--hidden' );
    }
  }
  showNext( next ) {
    this.slider.next();

    let prev = next.previousSibling;

    if ( prev.previousSibling.classList.contains( 'jump-navigation__button--hidden' )) {
      prev.previousSibling.classList.remove( 'jump-navigation__button--hidden' );
    }
  }
  checkButton() {
    let hiddenContainer = this.node.querySelector( '.jump-navigation__button--hidden' );
    if ( this.slider.currentSlide === 0 ) {
      this.node.querySelector( '.jump-navigation__button--left' ).classList.add( 'jump-navigation__button--hidden' );
    } else if ( this.slider.currentSlide === ( this.elementsLength - this.slider.perPage )) {
      this.node.querySelector( '.jump-navigation__button--right' ).classList.add( 'jump-navigation__button--hidden' );
    } else if ( hiddenContainer ) {
      hiddenContainer.classList.remove( 'jump-navigation__button--hidden' );
    }
  }
  findJumpMarks() {
    for ( let element of this.elements ) {

      let link = element.children[ 1 ];
      let href = link.getAttribute( 'href' );
      let pureHref = href.replace( '#', '' );
      let anchorElement = document.getElementById( pureHref );

      if ( anchorElement === null ) {
        let span = document.createElement( 'span' );
        span.innerText = pureHref;
        span.classList.add( 'jump-navigation__link' );
        element.classList.add( 'jump-navigation__item--disabled' );
        element.appendChild( span );
        element.removeChild( link );
        continue;
      } else {
        this.jumpMarks.push( anchorElement );
      }

      element.addEventListener( 'click', ( e ) => {
        e.preventDefault();

        let anchorPos = anchorElement.getBoundingClientRect().top;
        let bodyPos = document.body.getBoundingClientRect().top;
        let headerheight = ( window.innerWidth > 1023 ) ? 110 : 65;
        let toScroll = ( anchorPos - bodyPos ) - headerheight;

        if ( window.innerWidth >= 1024 && this.node.classList.contains( 'jump-navigation--slider' )) {
          // toScroll = toScroll - this.node.offsetHeight;
          window.scrollTo({ top: toScroll, behavior: 'smooth' });
        } else {
          window.scrollTo({ top: toScroll, behavior: 'smooth' });
        }

        let prevActive = this.node.querySelector( '.jump-navigation__item--active' );

        if ( prevActive ) {
          prevActive.classList.remove( 'jump-navigation__item--active' );
        }

        element.classList.add( 'jump-navigation__item--active' );
        this.checkSlider( element );
      });
    }

    this.addObserver();

  }
  checkSlider( element ) {
    let current = parseInt( element.getAttribute( 'data-id' ));
    if ( this.slider !== null ) {
      if (( this.slider.currentSlide + this.slider.perPage === current ) && current !== this.elements.length ) {
        this.node.querySelector( '.jump-navigation__button--right' ).click();
      } else if (( this.slider.currentSlide + 1 === current ) && current !== 0 ) {
        this.node.querySelector( '.jump-navigation__button--left' ).click();
      }
    }
  }
  addObserver() {
    let observer;

    let options = {
      root: null,
      rootMargin: '0%',
      threshold: 0.25
    };
    function setActive( entries ) {
      entries.forEach( entry => {

        if ( entry.isIntersecting ) {

          if (( this.scrollDirectionDown && entry.intersectionRect.top !== 0 ) || ( !this.scrollDirectionDown && entry.intersectionRect.top === 0 )) {
            let id = entry.target.id;

            let prevActive = this.node.querySelector( '.jump-navigation__item--active' );

            if ( prevActive ) {
              prevActive.classList.remove( 'jump-navigation__item--active' );
            }

            let containers = this.node.querySelectorAll( '.jump-navigation__item' );

            for ( let container of containers ) {
              if ( container.children[ 1 ].getAttribute( 'href' ).replace( '#', '' ) === id ) {
                container.classList.add( 'jump-navigation__item--active' );
                this.checkSlider( container );
                break;
              }
            }
          }
          entry.target.setAttribute( 'data-prevRatio', entry.intersectionRatio );
        }
      });
    }


    for ( let jumpMark of this.jumpMarks ) {
      let headerHeight = document.querySelector( '.header' ).offsetHeight + this.node.offsetHeight + 50;
      options.threshold = headerHeight / jumpMark.offsetHeight;
      if ( options.threshold > 1 ) {
        options.threshold = 1;
      } else if ( options.threshold < 0 ) {
        options.threshold = 0;
      }
      observer = new IntersectionObserver( setActive.bind( this ), options );
      observer.observe( jumpMark );
    }
  }
}

